<ng-container *transloco="let t">
  <a
    *ngIf="product?.inStock"
    class="button popsy-button-option full-width"
    (click)="openBuybackPromo()">
    <popsy-icon-trade-arrows class="icon"></popsy-icon-trade-arrows>
    <span class="text">{{
      lang === 'ar' ? 'احصل على هذا الجهاز بسعر أقل!' : 'Get this device for even less!'
    }}</span>
  </a>
</ng-container>
